module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"12 10.2 23.9 23.7\"><path d=\"M17 19.1c1.6 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.4-3 3-3m0-2c-2.7 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.3-5-5-5zM31.9 10.2c-2.2 0-4 1.8-4 4 0 .3.1.7.1 1l-5.4 2.7c.4.5.7 1.1 1 1.8L29 17c.7.8 1.8 1.3 2.9 1.3 2.2 0 4-1.8 4-4 0-2.3-1.8-4.1-4-4.1zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM31.9 25.9c-1.2 0-2.2.5-2.9 1.3l-5.3-2.8c-.2.6-.6 1.2-.9 1.8L28 29c-.1.3-.1.6-.1.9 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/sharing.svg
// module id = 93
// module chunks = 0